import Login from './Login';

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Login/index.ts